import gql from 'graphql-tag';

const CROP_IDENTIFIER_LIST = gql`
  query Query {
    cropIdentifiers {
      cropIdentifier
    }
  }
`;

export default CROP_IDENTIFIER_LIST;
